"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindClassToSelector = void 0;
function bindClassToSelector(classname, selector) {
    handle();
    const observer = onDOMChanged(handle);
    return () => {
        observer.disconnect();
        getElementsByClass(classname)
            .forEach(removeClass(classname));
    };
    function handle() {
        const shouldOnElements = new Set(selector());
        const shouldOffElements = getElementsByClass(classname)
            .filter(x => !shouldOnElements.has(x));
        shouldOnElements.forEach(addClass(classname));
        shouldOffElements.forEach(removeClass(classname));
    }
}
exports.bindClassToSelector = bindClassToSelector;
function addClass(classname) {
    return (element) => element.classList.add(classname);
}
function removeClass(classname) {
    return (element) => element.classList.remove(classname);
}
function getElementsByClass(classname) {
    return toArray(document.getElementsByClassName(classname));
}
function toArray(arrlike) {
    return Array.from(arrlike);
}
function onDOMChanged(callback) {
    const observer = new MutationObserver(callback);
    observer.observe(document.documentElement, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true
    });
    return observer;
}
//# sourceMappingURL=bind-class-to-selector.js.map